import { MenuActionTypes } from "./types";

export const menuToggle = (v: string): MenuActionTypes => {
  return {
    type: "TOGGLE",
    payload: v,
  };
};
